module.exports = __webpack_public_path__ + "media/assets/icons/explanation_of_bulk_quote_3-50882a50e55d16f9c1e70dea02e1925d.svg";